import { render, staticRenderFns } from "./CreateImaginaryCompany.vue?vue&type=template&id=866b3d24&scoped=true"
import script from "./CreateImaginaryCompany.vue?vue&type=script&lang=js"
export * from "./CreateImaginaryCompany.vue?vue&type=script&lang=js"
import style0 from "./CreateImaginaryCompany.vue?vue&type=style&index=0&id=866b3d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866b3d24",
  null
  
)

export default component.exports